import { memo } from 'react';

import type { IconProperties } from './types';

/**
 * Blox-Design plan toolbar — filter funnel (node 75644:10729).
 */
const PlanToolbarFilterIcon = ({
  width = 16,
  height = 16,
  color = 'currentColor',
}: IconProperties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
  >
    <path
      d='M10 16L6 13V9.58667L0.666666 3.58667V2C0.666666 1.46957 0.87738 0.960859 1.25245 0.585786C1.62753 0.210713 2.13623 0 2.66667 0H13.3333C13.8638 0 14.3725 0.210713 14.7475 0.585786C15.1226 0.960859 15.3333 1.46957 15.3333 2V3.58667L10 9.58667V16Z'
      fill={color}
    />
  </svg>
);

export default memo(PlanToolbarFilterIcon);
